const LOCALES = {
  ENGLISH: 'en',
};

export default LOCALES;
